import {
  IonButton,
  IonCol,
  IonGrid,
  IonModal,
  IonRow,
} from "@ionic/react";
import React, { useEffect, useRef, useState } from "react";
import { LoadStop } from "../loadStops/loadStops";
import { ShipmentDetails } from "../shipment-details/shipmentDetails";
import getTime from "../../../utils/getTimePeriod";
import "./GoogleShipmentMap.scss";
import { useHistory } from "react-router";

export type ShipmentMapProps = {
  shipments: any[];
  onCloseMapView: (shipent: any) => void;
};

type ShipmentMapBaseProps = ShipmentMapProps & {
  onDismissDialog: () => void;
  onOpenDialog: () => void;
  isDialog?: boolean;
};

type ShipmentWithCount = {
  shipment: any;
  loadStops: any[];
  totalShipments: number;
  locationName: string;
};

function getShipmentWithCount(shipments: any[]): ShipmentWithCount[] {
  let shipmentWithLocation: ShipmentWithCount[] = [];

  let locationName: string = "";

  shipments.forEach((shipment: any, index: number) => {
    let loadStops: any[] = (shipment && shipment.loadStop) || [];

    loadStops = loadStops.slice().sort((load1: any, load2: any) => {
      if (load1.sequenceNo && load2.sequenceNo) {
        return load1.sequenceNo - load2.sequenceNo;
      }
      if (load1.stopSequence && load2.stopSequence) {
        return load1.stopSequence - load2.stopSequence;
      }
      return 0;
    });

    if (loadStops.length > 0) {
      let city: string = loadStops[0].city;
      let state: string = loadStops[0].state;
      let country: string = loadStops[0].country;
      locationName = `${city ? city : ""}`;
      locationName = `${locationName ? `${locationName}, ` : ""}${
        state ? state : ""
      }`;
      locationName = `${locationName ? `${locationName}, ` : ""}${
        country ? country : ""
      }`;
    }
    if (locationName) {
      shipmentWithLocation.push({
        locationName: locationName.toUpperCase(),
        shipment: shipment,
        totalShipments: 1,
        loadStops: loadStops,
      });
    }
  });

  return shipmentWithLocation;
}

function getLocations(stops: ShipmentWithCount[]): string[] {
  const locations: string[] = [];
  stops.forEach((value: ShipmentWithCount, index: number) => {
    if (!locations.includes(value.locationName)) {
      locations.push(value.locationName);
    }
  });
  return locations;
}

let _markers: any[] = [];
const ShipmentMapBase: React.FunctionComponent<ShipmentMapBaseProps> = (
  props: ShipmentMapBaseProps
) => {
  const mapContainer = useRef<HTMLDivElement>(null);
  const [map, initializeMap] = useState<any>(null);
  const [bounds, setBounds] = useState<any>(null);
  const [geocoder, setGeocoder] = useState<any>(null);
  const [isMapVisible, setMapVisible] = useState<boolean>(false);
  const [shipmentsToShow, setShipmentToShow] = useState<ShipmentWithCount[]>(
    []
  );
  const [mapInitiated, initiateMap] = useState<boolean>(false);

  const _shipmentsWithCount: ShipmentWithCount[] = getShipmentWithCount(
    props.shipments
  );
  const locations: string[] = getLocations(_shipmentsWithCount);
  const history = useHistory();

  function geocodeAddress(
    location: string,
    _map: any,
    _bounds: any,
    _geocoder: any
  ) {
    const title = location;
    const address = location;
    const _shipments: ShipmentWithCount[] = _shipmentsWithCount.filter(
      (value: ShipmentWithCount) => value.locationName == title
    );
    const total = _shipments.length;
    const url = "";
    _geocoder.geocode(
      {
        address: location,
      },

      function(results: any, status: any) {
        if (status == google.maps.GeocoderStatus.OK) {
          const markerOption: any = {
            icon: "assets/icon/circle-map.svg",
            label: {
              text: `${total}`,
              color: "#31261D",
              fontSize: "18px"
            },
            map: _map,
            position: results[0].geometry.location,
            title: title,
            address: address,
            url: url,
          };
          const marker = new google.maps.Marker(markerOption);
          _markers.push(marker);
          marker.addListener("click", () => {
            setMapVisible(true);
            setShipmentToShow(_shipments);
          });
          _bounds.extend(marker.getPosition());
          _map.fitBounds(_bounds);

          if (_markers.length == 1) {
            const listener = google.maps.event.addListener(
              _map,
              "idle",
              function() {
                if (_map.getZoom() > 14) {
                  _map.setZoom(14);
                  google.maps.event.removeListener(listener);
                }
              }
            );
          }
        }
      }
    );
  }

  useEffect(() => {
    const __map = new google.maps.Map(mapContainer.current!, {
      center: { lat: 38.635361, lng: -90.200989 },
      zoom: 12,
      disableDefaultUI: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      mapTypeId: "terrain",
      zoomControl: true,
      fullscreenControl: false,
    });

    const __bounds: any = new google.maps.LatLngBounds();
    const __geocoder: any = new google.maps.Geocoder();

    const expandCtrl: HTMLButtonElement = document.createElement("button");
    expandCtrl.innerHTML = "Expand Map";
    expandCtrl.addEventListener("click", () => {
      props.onOpenDialog();
    });
    expandCtrl.className = "expand-map";

    const expandImg: HTMLImageElement = document.createElement("img");
    expandImg.className = "expand-img";
    expandImg.src = "assets/icon/expand.svg";

    expandCtrl.insertBefore(expandImg, expandCtrl.firstChild);

    const collapseCtrl: HTMLButtonElement = document.createElement("button");
    collapseCtrl.innerHTML = "Collapse Map";
    collapseCtrl.addEventListener("click", () => {
      props.onDismissDialog();
    });
    collapseCtrl.className = "collapse-map";

    const collapseImg: HTMLImageElement = document.createElement("img");
    collapseImg.className = "collapse-img";
    collapseImg.src = "assets/icon/Collapse.svg";

    collapseCtrl.insertBefore(collapseImg, collapseCtrl.firstChild);

    __map.controls[google.maps.ControlPosition.BOTTOM_LEFT].push(
      props.isDialog ? collapseCtrl : expandCtrl
    );
    _markers = [];
    for (let i = 0; i < locations.length; i++) {
      geocodeAddress(locations[i], __map, __bounds, __geocoder);
    }

    initializeMap(__map);
    setBounds(__bounds);
    setGeocoder(__geocoder);
    initiateMap(true);
  }, []);

  const pathname: string = history.location.pathname;

  useEffect(() => {
    if (
      mapInitiated &&
      locations &&
      locations.length > 0 &&
      map &&
      bounds &&
      geocoder
    ) {
      _markers = [];
      for (let i = 0; i < locations.length; i++) {
        geocodeAddress(locations[i], map, bounds, geocoder);
      }
    }
  }, [mapInitiated, pathname, locations.join("::")]);

  useEffect(() => {
    setMapVisible(false);
    if (map) {
      _markers.forEach((_m: any) => {
        _m.setMap(null);
      });
      _markers = [];
    }
  }, [props.shipments, pathname]);

  const calculateTime = (stop: any) => {
    return getTime(stop.appointmentFrom || "", stop.appointmentTo || "")
      .replace(/Z/g, "")
      .replace(/z/g, "");
  };

  const onClickLoadTile = (shipment: any) => {
    setMapVisible(false);
    props.onCloseMapView(shipment);
  };

  return (
    <div className="map-container">
      <div className="shipment-map" ref={mapContainer}></div>
      {isMapVisible && (
        <React.Fragment>
          <IonButton
            className="dismiss"
            onClick={() => {
              setMapVisible(false);
            }}
          >
            &times;
          </IonButton>
          <div className="shipment-details-map">
            {shipmentsToShow.map((_shipment: ShipmentWithCount) => {
              const loadStopsToShow: any[] = [];

              _shipment.loadStops.forEach((load: any, index: number) => {
                if (index == 0 || index == _shipment.loadStops.length - 1) {
                  loadStopsToShow.push(load);
                }
              });

              return (
                <div className="stop-grid-element">
                  <IonGrid
                    className="map-stop-details-grid"
                    onClick={() => {
                      onClickLoadTile(_shipment);
                    }}
                  >
                    <IonRow className="map-stop-details-row">
                      <IonCol size="5" className="map-stop-details-col">
                        <ShipmentDetails
                          {..._shipment.shipment}
                          isCarrierLoad={true}
                          showLoadNo={
                            !!_shipment.shipment.shipmentId ? false : true
                          }
                        />
                      </IonCol>
                      <IonCol size="7" className="map-stop-details-col">
                        <LoadStop
                          loadStops={loadStopsToShow}
                          calculateTime={calculateTime}
                          hideActivity={true}
                        />
                      </IonCol>
                    </IonRow>
                  </IonGrid>
                </div>
              );
            })}
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

const GoogleShipmentMap: React.FunctionComponent<ShipmentMapProps> = (
  props: ShipmentMapProps
) => {
  const [open, toggleDialog] = useState<boolean>(false);

  return (
    <React.Fragment>
      <IonModal backdropDismiss={false} cssClass="map-on-dlg" isOpen={open}>
        <ShipmentMapBase
          {...props}
          onDismissDialog={() => {
            toggleDialog(false);
          }}
          onOpenDialog={() => {
            toggleDialog(true);
          }}
          isDialog={true}
        />
      </IonModal>
      <ShipmentMapBase
        {...props}
        onDismissDialog={() => {
          toggleDialog(false);
        }}
        onOpenDialog={() => {
          toggleDialog(true);
        }}
      />
    </React.Fragment>
  );
};

export default GoogleShipmentMap;
